import type { ReactNode } from 'react';
import styles from './AccountPageHeader.module.scss';

interface Props {
  title: ReactNode;
  lead?: ReactNode;
}

export function AccountPageHeader({ title, lead }: Props): JSX.Element {
  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {lead ? <p className={styles.lead}>{lead}</p> : null}
    </header>
  );
}
